import { Component, Injector, Input, Optional } from '@angular/core';

import { ProjectregelStatusHistorieService } from 'src/app/core/service/projectregel-status-historie.service';
import { ProjectregelStatusHistorie } from 'src/app/core/dto/projectregel-status-historie';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Projectregel } from 'src/app/core/dto/projectregel';

@Component({
    selector: 'c-i-j-borculo-projectregel-status-historie-collection',
    templateUrl: './projectregel-status-historie-collection.component.html'/*,
    styleUrls: ['./projectregel-status-historie-collection.component.css'] */
})
export class ProjectregelStatusHistorieCollectionComponent extends PagedCollectionComponent<ProjectregelStatusHistorie> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<ProjectregelStatusHistorie>([
    	{ colDef: 'status', prop: x => x.status, searchable: SearchableType.String },
		{ colDef: 'datum', prop: x => x.datum, searchable: SearchableType.Date }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: ProjectregelStatusHistorieService, @Optional() protected filter: Filter<ProjectregelStatusHistorie>, injector: Injector) {
        super('/projectregelStatusHistorie/projectregelStatusHistorie', injector, ProjectregelStatusHistorie);

        this.initInput('projectregel', this.filterBuilder.equal(x => x.projectregel.id));            
        this.orderBy = [-2];

        this.filter.onGetChipLabel(x => x.status, () => 'Status');
        this.filter.onGetChipLabel(x => x.datum, () => 'Datum');

    }

    @Input() set projectregel(val: Projectregel) { this.handleInput('projectregel', val.id); }

    canDelete() {
        return false;
    }
}